import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import type { ArticleData } from '../types'
import { ArticleCard } from '../components/ArticleCard'

const leaderGallery = ['004.jpg', '007.jpg', '006.jpg', '005.jpg']

const institutionImages = [
  { image: '0017.jpg', label: 'البيت المحمدي', to: '/البيت-المحمدي' },
  { image: '0013.jpg', label: 'أكاديمية أهل الصفة', to: '/أكاديمية-أهل-الصفة-لدراسات-التصوف' },
  { image: '0014.jpg', label: 'مجلة أهل الصفة', to: 'https://ahlalsuffa.com/index.php/asshs/index', external: true },
  { image: '0015.jpg', label: 'الطريقة المحمدية الشاذلية', to: '/الطريقة-المحمدية-الشاذلية' },
  { image: '0016.jpg', label: 'الإمام الرائد', to: '/الإمام-الرائد' },
]

export function HomePage({ articles }: { articles: ArticleData[] }) {
  const [activeImage, setActiveImage] = useState(0)
  const latestEvents = articles.slice(0, 3)

  useEffect(() => {
    const timer = window.setInterval(() => setActiveImage((current) => (current + 1) % leaderGallery.length), 4500)
    return () => window.clearInterval(timer)
  }, [])

  return (
    <>
      <section className="home-hero" aria-label="البيت المحمدي">
        <div className="hero-action">
          <Link className="button button-light" to="/أحدث-الفعاليات">أحدث الفعاليات</Link>
        </div>
      </section>

      <section className="institution-showcase" aria-label="مؤسسات البيت المحمدي">
        <div className="home-shell showcase-grid">
          {institutionImages.map((item) => {
            const image = <img src={`/assets/media/2025/12/${item.image}`} alt={item.label} />
            return item.external
              ? <a key={item.image} href={item.to} target="_blank" rel="noreferrer">{image}</a>
              : <Link key={item.image} to={item.to}>{image}</Link>
          })}
        </div>
      </section>

      <section className="leader-section">
        <div className="home-shell split-layout">
          <div className="section-copy reveal-copy">
            <h1>السيد محمد زكي إبراهيم</h1>
            <p>هو العالِمُ الموسوعي ،المحدث، الفقيه، الداعيةُ، القُطبُ، المُجاهدُ، الكاتبُ، الخطيبُ، الشاعرُ، العارفُ بالله، العابد، الزاهد، قطب اقطاب عصره، الشريف، الحسيني، الحنفي، الأزهري، الشاذلي: محمد زكي إبراهيم، رائد العشيرة المحمدية، اسمه: محمد، ولقبه: عُرف بعدة ألقاب منها: زكي الدين والإمام الرائد، وكنيته : أبو البركات، و هو شريف حسيني الأب و حسني الأم.</p>
            <Link className="button" to="/الإمام-الرائد">اقرأ المزيد</Link>
          </div>
          <div className="leader-gallery">
            <img src={`/assets/media/2025/12/${leaderGallery[activeImage]}`} alt="السيد محمد زكي إبراهيم" />
            <div className="gallery-dots" role="group" aria-label="اختيار صورة">
              {leaderGallery.map((image, index) => (
                <button key={image} className={activeImage === index ? 'active' : ''} onClick={() => setActiveImage(index)} aria-label={`الصورة ${index + 1}`} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="events-section">
        <div className="home-shell">
          <div className="section-heading">
            <h2>أحدث الفاعليات</h2>
          </div>
          <div className="articles-grid">
            {latestEvents.map((article) => <ArticleCard article={article} variant="home" key={article.id} />)}
          </div>
        </div>
      </section>

      <section className="complex-section">
        <div className="home-shell complex-grid">
          <div className="complex-feature">
            <h2>المجمع العلمي</h2>
            <h3>الهيئة العلمية العليا بالبيت المحمدي</h3>
            <div className="complex-image"><span>المجمع العلمي</span></div>
          </div>
          <div className="complex-links">
            <InstitutionLink title="أكاديمية أهل الصفة لدراسات التصوف وعلوم التراث" to="/أكاديمية-أهل-الصفة-لدراسات-التصوف">
              الأكاديمية كهيئة علمية تعنى بالعمل على إحياء التراث الحضاري للأمة في كافة مجالات العلم والمعرفة والعمارة والفنون والآداب والتربية والفكر والثقافة.
            </InstitutionLink>
            <InstitutionLink title="المجالس المحمدية" to="/المجمع-العلمي">
              مجالس علمية تهدف إلى ترسيخ الوعي الصحيح، والفهم المنضبط لعلوم الشريعة واللغة والتراث الإسلامي عموماً، لتكون ملاذاً آمناً لراغبي العلوم الشرعية.
            </InstitutionLink>
            <InstitutionLink title="المجالس الحديثية" to="/المجالس-الحديثة">
              مجالس حديثية متخصصة تهدف إلى إحياء سنة الإقراء والسماع العريقة، وصيانة خصيصة الإسناد المتصل التي تفردت بها الأمة المحمدية.
            </InstitutionLink>
          </div>
        </div>
      </section>
    </>
  )
}

function InstitutionLink({ title, to, children }: { title: string; to: string; children: string }) {
  return (
    <article className="institution-link">
      <h3>{title}</h3>
      <p>{children}</p>
      <Link className="button" to={to}>اقرأ المزيد</Link>
    </article>
  )
}
